import angular from 'angular';

import { SearchLegacyController } from './search-legacy.controller.js';
import { SearchController } from './search.controller.js';
import { SearchService } from './search.services.js';
import { SelectArchivableController } from './select-archivable.controller.js';
import {
  checkboxesSelector,
  checkboxesWithChildrenSelector,
  dayrangeSelector,
  textsSelector,
} from './selectors.directives.js';
import { SearchSelectorsFactory } from './selectors.service.js';

angular
  .module('search', [])
  .factory('SearchFactory', SearchService.SearchFactory)
  .factory('SearchSelectorsFactory', SearchSelectorsFactory)
  .directive('textsSelector', textsSelector)
  .directive('checkboxesSelector', checkboxesSelector)
  .directive('checkboxesWithChildrenSelector', checkboxesWithChildrenSelector)
  .directive('dayrangeSelector', dayrangeSelector)
  .controller('SearchController', SearchController)
  .controller('SearchLegacyController', SearchLegacyController)
  .controller('SelectArchivableController', SelectArchivableController);
